<template>
  <div class="sendTask_box">
    <div class="header">
      <div class="header_title">{{ title }}</div>
      <div class="header_name">评分对象：{{ enterpriseName }}</div>
      <div class="header_num">当前诚信指数：{{ score }}分</div>
    </div>
    <div class="exitSupervision_bottom">
      <div class="result line_bottom">
        <div class="title">
          <div>创建任务</div>
        </div>
      </div>
      <div class="toBeRectified">
        <div class="companyName line_bottom">
          <div class="left">
            <span>任务名称</span>
            <span>*</span>
          </div>
          <div class="right">
            <input type="text" placeholder="待填写" v-model="inputText">
          </div>
        </div>
        <div class="companyName line_bottom">
          <div class="left">
            <span>目标完成日期</span>
            <span>*</span>
          </div>
          <div class="right" @click="suitDay">
            <span>{{time === '' ? '待选择': time}}</span>
            <img src="../../../../assets/image/ic_jt_ck@2x.png" alt />
          </div>
        </div>
        <div class="companyName line_bottom">
          <div class="left">
            <span>受委托方</span>
            <span>*</span>
          </div>
          <div class="right" @click="suitType">
            <span>{{name === '' ? '待选择': name}}</span>
            <img src="../../../../assets/image/ic_jt_ck@2x.png" alt />
          </div>
        </div>
        <div class="companyName">
          <div class="left">
            <span>评价标准</span>
            <span>*</span>
          </div>
          <div class="right" @click="suitEvaluate">
              <span>{{text === '' ? '待选择': text}}</span>
              <img src="../../../../assets/image/ic_jt_ck@2x.png" alt />
            <!-- <img src="../../../../assets/image/ic_jt_ck@2x.png" alt /> -->
          </div>
        </div>
      </div>
    </div>
    <div class="bottomBtn">
      <div class="btn" :class="{'active': showBtn}" @click="sent">发布</div>
    </div>
    <timePick @getTimeValue="getTimeValue" ref="timePick"></timePick>
    <common-picker ref="commonPicker1" :typeList="gradeNormalList"  :cols="colsDetail1" @getTypeValue="typeListDetail1"></common-picker>
    <common-picker ref="commonPicker2" :typeList="gradeList"  :cols="colsDetail" @getTypeValue="typeListDetail"></common-picker>
  </div>
</template>
<script>
    import timePick from '../../../../components/base/timePick';
    import commonPicker from '../../../../components/base/commonPicker';
    import api from '../../../../service/modules/integrity';

    export default {
        components: {
            timePick,
            commonPicker
        },
        data () {
            return {
                enterpriseName: this.$route.query.enterpriseName,
                title: this.$route.query.title,
                score: this.$route.query.score,
                name: '',
                nameId: '',
                time: '', // 日期
                text: '',
                textId: '',
                inputText: '',
                gradeList: [],
                gradeNormalList: [[
                    {
                        text: '2020年旅游景区品质指数标准'
                    },
                    {
                        text: '2019年旅游景区品质指数标准'
                    }
                ]],
                colsDetail: 1,
                colsDetail1: 1
            }
        },
        created () {
            this.getGradeList();
            this.getGradeNormalList();
        },
        computed: {
            showBtn () {
                if (this.inputText && this.text && this.name && this.time) {
                    return true;
                } else {
                    return false
                }
            }
        },
        methods: {

            // 受委托方
            getGradeList () {
                api.gradeList().then(res => {
                    if (res.ret === 0) {
                        let arr = []
                        arr = res.data.map(({ gradeUnitId, gradeUnitName }) => {
                            return {
                                value: gradeUnitId,
                                text: gradeUnitName
                            }
                        })
                        this.gradeList.push(arr)
                    }
                })
            },
            // 评分标准选择
            getGradeNormalList () {
                api.gradeNormalList({ enterpriseGradeId: this.$route.query.enterpriseGradeId }).then(res => {
                    if (res.ret === 0) {
                        this.gradeNormalList = [res.data.map(({ normalId, normalName }) => {
                            return {
                                text: normalName,
                                value: normalId
                            }
                        })]
                        console.log(res.data, '44444444')
                    }
                })
            },
            goTrustee () {
                this.show = true;
            },
            // 选择日期
            getTimeValue (val) {
                this.time = val;
            },
            // 时间日期
            suitDay () {
                this.$refs.timePick.showPicker();
            },
            suitType () {
                this.$refs.commonPicker2.showPicker();
            },
            typeListDetail1 (val) {
                this.text = val[0].text;
                this.textId = val[0].value;
            },
            typeListDetail (val) {
                this.name = val[0].text;
                this.nameId = val[0].value;
            },
            suitEvaluate () {
                this.$refs.commonPicker1.showPicker();
            },
            // 发布
            sent () {
                if (this.inputText && this.text && this.name && this.time) {
                    let params = {
                        taskName: this.inputText,
                        endDate: this.time,
                        gradeUnitId: this.nameId,
                        gradeUnitName: this.name,
                        normalId: this.textId,
                        normaName: this.text,
                        enterpriseGradeId: this.$route.query.enterpriseGradeId,
                        id: this.$route.query.id,
                        enterpriseName: this.enterpriseName
                    }
                    api.taskDistribution(params).then(res => {
                        if (res.ret === 0) {
                            yyn.invokeJSB('closeWindow'); /** 跳转到tio首页 */
                            this.$Toast({
                                message: '处理成功',
                                icon: 'passed'
                            });
                        }
                    })
                }
            }
        }
    }
</script>
<style lang="less" scoped>
.sendTask_box {
  padding: 20px 12px 0px;
  .header {
    width:351px;
    height:104px;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;
    padding: 16px;
    .header_title {
      font-size:16px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:rgba(51,51,51,1);
      line-height:16px;
    }
    .header_name {
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(102,102,102,1);
      line-height:14px;
      padding: 16px 0px;
    }
    .header_num {
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(102,102,102,1);
      line-height:14px;
    }
  }
  .exitSupervision_bottom {
    width: 100%;
    background-color: #fff;
    float: left;
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;
    margin-bottom: 94px;
    margin-top:16px;
    .result {
      width: 100%;
      padding: 16px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title {
        font-size: 14px;
        color: #333;
        font-weight: 600;
        display: flex;
        justify-content: space-between;
      }
    }
    .toBeRectified {
      width: 100%;
      height: 100%;
      .companyName,
      .jurisdiction,
      .supervisionDate {
        height: 62px;
        width: 100%;
        line-height: 62px;
        padding: 0 16px;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        .left {
          color: #999;
          span:nth-child(2) {
            color: #FF4D4D;
          }
        }
      }
      .jurisdiction{
        .right{
          width: 160px;
          text-align: right;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .companyName {
        line-height: center;
        .right{
          display: flex;
          justify-content: space-around;
          input {
            text-align: right;
          }
          span{
            display: inline-block;
            width: 160px;
            text-align: right;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          img{
            display: inline-block;
            width: 12px;
            height: 12px;
            margin-left: 4px;
            margin-top: 24px;
          }
        }
      }
    }
  }
  .bottomBtn {
    width:100%;
    height:73px;
    background:rgba(255,255,255,1);
    box-shadow:0px -2px 8px 0px rgba(0,0,0,0.03);
    position: fixed;
    bottom: 0px;
    left: 0px;
    padding: 12px;
    z-index: 99;
    .btn {
      width:351px;
      height:50px;
      background:rgba(54,179,116,0.5);
      border-radius:3px;
      line-height: 50px;
      color: #fff;
      font-size: 16px;
      text-align: center;
    }
    .active {
      background:rgba(54,179,116,1);
    }
  }
}
</style>
